import { useCallback, useState } from 'react';

import { Typography } from '@mui/material';

import { IIneligibleLender } from '@modules/ContactManager/components/Tabs/shared/DealCalculator/models/IneligibleLender';
import { muiTheme } from '@styles/muiTheme';
import { ExcludedLenderFooter, 
         ExcludedLenderHeader, 
         ExcludedLenderText, 
         ExcludedLenderWrapper } from '@styles/ContactManager/DealCalculator/LenderSectionStyles';
import { SaveButton } from '@shared/components/SaveButton';
import { formatDate } from '@shared/commonFunctions';
import { dateFormatWithTime } from '@shared/constants/formats';
import { requestExcludeLender, requestIncludeLender } from './queries';

interface IExcludedLenderProps {
  lender: IIneligibleLender;
  leadId?: string;
  onSave(): void;
  reloadDealCalculator: () => void;
}

export const ExcludedLender = ({ lender, leadId = '', reloadDealCalculator }: IExcludedLenderProps) => {
  const [reason, setReason] = useState(lender.reason || '');

  const onInclude = async() => {
    await requestIncludeLender(lender.code.toLowerCase(), leadId);
    reloadDealCalculator();
  };

  const onSave = useCallback(async() => {
    if (reason) {
      lender && (await requestExcludeLender(lender.code.toLowerCase(), leadId || '', reason, true));
      reloadDealCalculator();
    }
  }, [lender, reason, leadId]);

  return (
    <ExcludedLenderWrapper>
      <ExcludedLenderHeader>
        <b>{lender.name}</b>
        {lender.isManualExclude && <span>{formatDate(lender.manualExcludeDateTime, { format: dateFormatWithTime })}</span>}
      </ExcludedLenderHeader>

      <ExcludedLenderText
        minRows={4}
        value={reason}
        disabled={!lender.isManualExclude}
        onChange={(event) => setReason(event.target.value)}
      />
      {!reason &&
        <Typography variant='caption' color={muiTheme.palette.error.main}>Reason is required.</Typography>
      }

			<ExcludedLenderFooter>
        { lender.isManualExclude &&
          <>
            <span onClick={onInclude}>Include</span>
            <SaveButton label='Save' variant="contained" position='initial' width='64px' onClick={onSave} />

          </>
        }
      </ExcludedLenderFooter>
    </ExcludedLenderWrapper>
  );
};
